import { Injectable } from "@angular/core";
import { XsAppConfigService } from "../../common/services/xs-app-config.service";

@Injectable({
  providedIn: "root"
})
export class CoreCommonService {
  public APPLICATION_APP_API_HOST: string = "";
  public APPLICATION_APP_HOST: string = "";
  public APPLICATION_URL_PUBLICA: string = "";
  public ID_APLICATION: string = "0";
  public URL_CASILLA: string = "";

  public SUNAT_URL: string = "";
  public CASILLA_URL: string = "";

  constructor(public xsAppConfigService: XsAppConfigService) {
    switch (xsAppConfigService.APLICACION_AMBIENTE) {
      case "localhost-nologin":
        this.APPLICATION_APP_API_HOST = "http://localhost:8090/api";
        // this.APPLICATION_APP_HOST = "http://localhost:8090";
        this.APPLICATION_APP_HOST = "http://localhost:4200";
        this.APPLICATION_URL_PUBLICA = "http://localhost:8090";
        this.ID_APLICATION = "223";
        this.SUNAT_URL = "https://api-seguridad-desa.sunat.gob.pe:444/v1/clientessol/07409340-338b-4dd0-aa7e-f3bc1b07eb61/oauth2/authen?client_id=07409340-338b-4dd0-aa7e-f3bc1b07eb61&response_type=code&state=s&redirect_uri=https://desarrollo.oefa.gob.pe/ce-resp-sso-sunat";
        break;
      case "localhost":
        break;
      case "desarrollo":
        break;
      case "desarrollo-publico":
        break;
      case "calidad":
           break;
      case "produccion":
           break;
    }
  }
}
